// extracted by mini-css-extract-plugin
export default {"bottomRightPosition":"WS7NMdw24BRsiS4TirPX"};